import EmailTagRule from './email-tag-rule';

const EmailFormItems = {
    TagRule: EmailTagRule,
};

export default EmailFormItems;